/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Nav_ResellersInputs */

const id_staff_nav_resellers = /** @type {(inputs: Staff_Nav_ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseller`)
};

const en_staff_nav_resellers = /** @type {(inputs: Staff_Nav_ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resellers`)
};

/**
* | output |
* | --- |
* | "Resellers" |
*
* @param {Staff_Nav_ResellersInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_nav_resellers = /** @type {((inputs?: Staff_Nav_ResellersInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Nav_ResellersInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_nav_resellers(inputs)
	return id_staff_nav_resellers(inputs)
});